export function BorderButton({ children, onClick }) {
  return (
    <button
      onClick={onClick}
      className="flex items-center justify-start space-x-1 
        text-sm font-medium 
        text-slate-800 dark:text-slate-200 border-1 border-gray-600 dark:border-gray-400
        hover:bg-slate-300/40 px-3 py-2 rounded-lg 
        cursor-pointer
        hover:shadow-xl hover:shadow-blue-500/20 transition-all duration-300 group"
    >
      {children}
    </button>
  );
}